import useStyleVars from '@hooks/useStyleVars';
import useMatchMedia from '@hooks/useMatchMedia';

export default function useIsMobile() {
  const { controlsMobileWidth } = useStyleVars();
  const isMobile = useMatchMedia(controlsMobileWidth);

  return isMobile;
}
